<div class="container">
    <div [ngSwitch]="action">
        <!-- password reset -->
        <div *ngSwitchCase="'resetPassword'">
        <app-reset-password></app-reset-password>
        </div>

        <!-- verify email address -->
        <div *ngSwitchCase="'verifyEmail'">
        <app-verify-email></app-verify-email>
        </div>

        <!-- default action -->
        <div *ngSwitchDefault>
            <div class="card">
                <div class="card-body">
                    <h3>Error</h3>
                    <p>Unknown mode</p>
                </div>
            </div>
        </div>
    </div>
</div>